export default "__VITE_ASSET__BE7fGY3w__"